// extracted by mini-css-extract-plugin
export default {"addButton":"_2sCv"};